import authHeader from "./auth.header"
import { ApiError, apiFetch } from './api.js'
import constants from './constants.js'

const HOST_URL = constants.API_URL;
const fetch = apiFetch

async function getAllFriends(){
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return

    const response = await fetch(`${HOST_URL}/users/${userId}/friends`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function getAllFriendsWithSharedReviews() {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return

    const response = await fetch(`${HOST_URL}/users/${userId}/friends-with-shared-reviews`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

// invitations reçues par le user
async function getFriendRequests(){
    try {
        const userId = JSON.parse(localStorage.getItem('user')).id
        if (!userId) return
    
        const response = await fetch(`${HOST_URL}/users/${userId}/friends/requests`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return []
        }

        return (await response.json()).friend_requests || []
    }
    catch (err) {
        console.log("err at getFriendRequests", err)
        return []
    }
}

// invitations envoyees par le user
async function getInvitations(){
    try {
        const userId = JSON.parse(localStorage.getItem('user')).id
        if (!userId) return
    
        const response = await fetch(`${HOST_URL}/users/${userId}/friends/invitations`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return []
        }
      
        return (await response.json()).friend_requests || []
    }
    catch (err) {
        console.log("err at getInvitations", err)
        return []
    }
}

// Ajouter un ami (invitation)
async function addFriend(friendId){
    try {
        const userId = JSON.parse(localStorage.getItem('user')).id
        if (!userId) return
    
        const response = await fetch(`${HOST_URL}/users/${userId}/friends/${friendId}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return []
        }
        else {
            console.log("Ajout ami ok\n. response code, ", response.code)
        }
        return (await response.json()).friend_requests || []
    }
    catch (err) {
        console.log("err at ajout ami", err)
        return []
    }
}
async function searchFriends(s) {
    try { 
        if (!s) return 
        const id = JSON.parse(localStorage.getItem('user')).id
        const response = await fetch(`${HOST_URL}/users/${id}/searchfriends/${s}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
         
        return await response.json()
    }
    catch (err) {
        console.log("err at searchFriend", err)
    }
}
async function searchUsers(s) {
    const id = JSON.parse(localStorage.getItem('user')).id
    if(s === ''){ s = 'all'} //  si vide on veut tout
    try { 
        if (!s) return 
        const response = await fetch(`${HOST_URL}/users/${id}/searchusers/${s}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
         
        return await response.json()
    }
    catch (err) {
        console.log("err at searchUsers", err)
    }
}
async function acceptFriendship(friendId){
    try {
        const userId = JSON.parse(localStorage.getItem('user')).id
        if (!userId) return
    
        const response = await fetch(`${HOST_URL}/users/${userId}/friends/${friendId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
       
        return true
    }
    catch (err) {
        console.log("err at acceptFriendship", err)
    }
}

export async function removeFriend(friendId) {
    try {
        const userId = JSON.parse(localStorage.getItem('user')).id
        if (!userId) return
    
        const response = await fetch(`${HOST_URL}/users/${userId}/friends/${friendId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        
        console.log(await response.json())
        return true
    }
    catch (err) {
        console.log("err at removeFriend", err)
    }
}

export async function getAllPublicUsers(){
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return

    const response = await fetch(`${HOST_URL}/users/public/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }
    console.log('API call ok')
    return response.json()
}

async function getSuggestedFriends(){
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return

    const response = await fetch(`${HOST_URL}/users/${userId}/suggestedfriends`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    } 
    return response.json()
}
async function getFriend(friendId){
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return

    const response = await fetch(`${HOST_URL}/users/${userId}/friends/${friendId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    } 
    return await response.json()
}

async function updatePrivacySetting(id) {
    try { 
        if (!id) return 
        const response = await fetch(`${HOST_URL}/users/${id}/updateprivate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        
        return true
    }
    catch (err) {
        console.log("err at removeFriend", err)
    }
}

export async function updateUser(id, request) {
    console.log('send requet to API')
    try { 
        if (!id) return 'No user id get lost'
        const response = await fetch(`${HOST_URL}/users/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify(request) // Ajout du contenu de 'request' au corps de la requête
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        
       const responseData = await response.json()
       console.log(responseData)

       return responseData;
    }
    catch (err) {
        console.log("err at updateUser", err)
    }
}

async function setProfilePic(id, imageFile) { 
    try { 
        if (!id) return 'No user id get lost' 
            const formData = new FormData();
            formData.append('file', imageFile); 
            const response = await fetch(`${HOST_URL}/users/${id}/profile-picture`, {
                method: 'POST',
                // headers: {
                //     'Content-Type': 'multipart/form-data',
                //     'Accept': 'multipart/form-data',
                //     ...authHeader()
                // },
                body: formData
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
         
       return response.url;
    }
    catch (err) {
        console.log("err at set Profile pic for user", err)
    }
}

export async function getUserIdFromEmail(email) {
    try {
        const response = await fetch(`${HOST_URL}/users/email/${email}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })

        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return []
        }

        return await response.json()
    } catch (err) {
        console.log("err at getUserIdFromEmail", err)
    }
}

export async function getUserReviews(userId) {
    if(!localStorage.getItem('user')) return
    if (!userId) return
    const response = await fetch(`${HOST_URL}/users/${userId}/reviews`, {
        method: 'GET', 
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return false
    }

    return await response.json()
}
export async function getArticle(articleId) {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/articles/${articleId}`, {
        method: 'GET', 
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    console.log('Fetch article id '+articleId)
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function getNotifications() {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return
    const response = await fetch(`${HOST_URL}/notifications/${userId}`, {
        method: 'GET', 
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function sendArticleReadNotification(articleId, userId) {
    try {
        const response = await fetch(`${HOST_URL}/notifications/article/read`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify({ article_id: articleId, user_id: userId })
        })

        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }

        return await response.json()
    } catch (err) {
        console.log("err at sendArticleReadNotification", err)
        return false
    }
}

export async function sendReviewReadNotification(reviewId, userId) {
    try {
        const response = await fetch(`${HOST_URL}/notifications/review/read`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify({ review_id: reviewId, user_id: userId })
        })

        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }

        return await response.json()
    } catch (err) {
        console.log("err at sendReviewReadNotification", err)
        return false
    }
}

export async function getTutorialByPage(page) {
    if (!localStorage.getItem("user")) return null
    const link = page || window.location.pathname || "/"
    const response = await fetch(`${HOST_URL}/tutorial/get`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ link })
    })

    if (!response.ok) {
        if (response.status === 404) {
            return null
        }
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return null
    }

    return await response.json()
}

export async function getNotificationsPaginated(firstElement, lastElement, query = '') {
    const userId = JSON.parse(localStorage.getItem('user')).id
    if (!userId) return []

    const safeFirst = Number.isInteger(firstElement) ? firstElement : 0
    const safeLast = Number.isInteger(lastElement) ? lastElement : 9
    const safeQuery = (query || '').trim()
    const url = safeQuery.length > 0
        ? `${HOST_URL}/notifications/${userId}/${safeFirst}/${safeLast}/${encodeURIComponent(safeQuery)}`
        : `${HOST_URL}/notifications/${userId}/${safeFirst}/${safeLast}`

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    return await response.json()
}

export async function updateSeenNotification(notificationId) {
    try {
        const response = await fetch(`${HOST_URL}/notifications/see`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ notificationId })
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.message);
        }

        return data;
    } catch (error) {
        console.error('Error marking notification as seen:', error);
        throw error;
    }
}

export async function deleteNotification(notificationId) {
    try {
        const userId = JSON.parse(localStorage.getItem('user')).id
        if (!userId) return
    
        const response = await fetch(`${HOST_URL}/notifications/delete`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify({ notificationId })
        })
    
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        
        console.log(await response.json())
        return true
    }
    catch (err) {
        console.log("err at removeNotification", err)
    }
}

export async function getCountUserNotifications(userId)
 {
    const response = await fetch(`${HOST_URL}/notifications/count/${userId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.json())
        return []
    }

    const jsonResponse = await response.json()
    return jsonResponse
 }

 export const isUserSubscribed = async (userId) => {
    try {
        const response = await fetch(HOST_URL + "/subscription/users/" + userId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            return Promise.reject(errorData);
        }

        const data = await response.json();
        return Promise.resolve(data);
    } catch (error) {
        console.error(error);
        return Promise.reject({ message: "Une erreur inconnue est survenue." });
    }
}

export async function getGCU() {
    const response = await fetch(`${HOST_URL}/options/gcu`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getLegalNotices() {
    const response = await fetch(`${HOST_URL}/options/legal_notices`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getPrivacyPolicy() {
    const response = await fetch(`${HOST_URL}/options/privacy_policy`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getAbout() {
    const response = await fetch(`${HOST_URL}/options/about`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }
    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getContactEmail() {
    const response = await fetch(`${HOST_URL}/options/contact_email`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getUserConsent(userId) {
    if (!userId) {
        return { user_id: null, consent: 0 }
    }

    const response = await fetch(`${HOST_URL}/users/${userId}/consent`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return { user_id: userId, consent: 0 }
    }

    return await response.json()
}

export async function acceptUserConsent(userId) {
    if (!userId) {
        return false
    }

    const response = await fetch(`${HOST_URL}/users/${userId}/consent`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }

    const jsonResponse = await response.json()
    return jsonResponse
}

export async function createTokenToStatic(userId) {
    // générer un token avec des caractères aléatoires
    const token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const response = await fetch(`${HOST_URL}/users/token/static/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ user_id: userId, token })
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }
    return token
}

export async function getUserProfile(userId) {
    const response = await fetch(`${HOST_URL}/users/profile/${userId}`, {
        method: 'GET',
        allowForbiddenResponse: true,
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    let responseData = null
    try {
        responseData = await response.json()
    } catch (error) {
        responseData = null
    }

    if (!response.ok) {
        if (response.status === 403) {
            throw new ApiError(403, responseData?.message || 'Ce profil est privé')
        }
        if (response.status === 404) {
            throw new ApiError(404, responseData?.message || "Ce profil n'existe pas")
        }
        throw new ApiError(response.status, responseData?.message || "Impossible de charger le profil")
    }

    return responseData
}

export async function getUsersByLinkedIgo(igoId) {
    const response = await fetch(`${HOST_URL}/users/igo/igo/${igoId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }
    const jsonResponse = await response.json()
    return jsonResponse
}

export async function getIgoFromUser(userId) {
    const response = await fetch(`${HOST_URL}/users/igo/user/${userId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }
    const jsonResponse = await response.json()
    return jsonResponse
}

export async function addIgoToUser(userId, igoId, isPrivate = false) {
    const response = await fetch(`${HOST_URL}/users/igo/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ user_id: userId, igo_id: igoId, private: isPrivate ? 1 : 0 })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }
    return true
}

export async function deleteIgoFromUser(userId, igoId) {
    const response = await fetch(`${HOST_URL}/users/igo/delete`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ user_id: userId, igo_id: igoId })
    })
    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }
    return true
}

export async function setIgoPrivate(userId, igoId, isPrivate) {
    const response = await fetch(`${HOST_URL}/users/igo/private`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ user_id: userId, igo_id: igoId, private: isPrivate ? 1 : 0 })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }
    return true
}

export async function setAllIgoPrivate(userId, isPrivate) {
    const response = await fetch(`${HOST_URL}/users/igo/private/all`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ user_id: userId, private: isPrivate ? 1 : 0 })
    })

    if (!response.ok) {
        console.log("request failed\n. response code, ", response.code)
        console.log("response payload, ", await response.text())
        return false
    }
    return true
}

export async function createFriendGroup(payload) {
    try {
        const response = await fetch(`${HOST_URL}/users/friend-groups`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify(payload || {})
        })
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        return await response.json()
    } catch (err) {
        console.log("err at createFriendGroup", err)
        return false
    }
}

export async function getFriendGroupsByUser(userId) {
    try {
        const id = userId || JSON.parse(localStorage.getItem('user')).id
        if (!id) return
        const response = await fetch(`${HOST_URL}/users/${id}/friend-groups`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return []
        }
        return await response.json()
    } catch (err) {
        console.log("err at getFriendGroupsByUser", err)
        return []
    }
}

export async function getFriendsByGroup(userId, groupId) {
    try {
        const id = userId || JSON.parse(localStorage.getItem('user')).id
        if (!id || !groupId) return
        const response = await fetch(`${HOST_URL}/users/${id}/friend-groups/${groupId}/friends`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return []
        }
        return await response.json()
    } catch (err) {
        console.log("err at getFriendsByGroup", err)
        return []
    }
}

export async function addFriendToGroup(userId, groupId, friendId) {
    try {
        const id = userId || JSON.parse(localStorage.getItem('user')).id
        if (!id || !groupId || !friendId) return false
        const response = await fetch(`${HOST_URL}/users/${id}/friend-groups/friends/add`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify({ group_id: groupId, user_id: friendId })
        })
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        return await response.json()
    } catch (err) {
        console.log("err at addFriendToGroup", err)
        return false
    }
}

export async function removeFriendFromGroup(userId, groupId, friendId) {
    try {
        const id = userId || JSON.parse(localStorage.getItem('user')).id
        if (!id || !groupId || !friendId) return false
        const response = await fetch(`${HOST_URL}/users/${id}/friend-groups/friends/remove`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify({ group_id: groupId, user_id: friendId })
        })
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        return await response.json()
    } catch (err) {
        console.log("err at removeFriendFromGroup", err)
        return false
    }
}

export async function deleteFriendGroup(userId, groupId) {
    try {
        const id = userId || JSON.parse(localStorage.getItem('user')).id
        if (!id || !groupId) return false
        const response = await fetch(`${HOST_URL}/users/${id}/friend-groups/${groupId}/delete`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        return await response.json()
    } catch (err) {
        console.log("err at deleteFriendGroup", err)
        return false
    }
}

export async function leaveFriendGroup(userId, groupId) {
    try {
        const id = userId || JSON.parse(localStorage.getItem('user')).id
        if (!id || !groupId) return false
        const response = await fetch(`${HOST_URL}/users/${id}/friend-groups/leave`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
            body: JSON.stringify({ group_id: groupId })
        })
        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.json())
            return false
        }
        return await response.json()
    } catch (err) {
        console.log("err at leaveFriendGroup", err)
        return false
    }
}

async function getLatestUserActivity(userId, endpoint) {
    try {
        if (!userId) return null
        const response = await fetch(`${HOST_URL}/users/${userId}/${endpoint}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                ...authHeader()
            },
        })

        if (!response.ok) {
            console.log("request failed\n. response code, ", response.code)
            console.log("response payload, ", await response.text())
            return null
        }

        const payload = await response.json()
        if (Array.isArray(payload)) return payload[0] || null
        if (Array.isArray(payload?.data)) return payload.data[0] || null
        if (Array.isArray(payload?.items)) return payload.items[0] || null
        return payload?.data || payload
    } catch (err) {
        console.log(`err at getLatestUserActivity ${endpoint}`, err)
        return null
    }
}

export const getLatestArticleComment = (userId) =>
    getLatestUserActivity(userId, 'articles/latest-comment')

export const getLatestArticleLike = (userId) =>
    getLatestUserActivity(userId, 'articles/latest-like')

export const getLatestReviewComment = (userId) =>
    getLatestUserActivity(userId, 'reviews/latest-comment')

export const getLatestReviewLike = (userId) =>
    getLatestUserActivity(userId, 'reviews/latest-like')

export const getLatestProfileFeedMessage = (userId) =>
    getLatestUserActivity(userId, 'profile-feed/latest')

export async function getLatestFriendArticle(userId) {
    if (!userId) return null

    const response = await fetch(`${HOST_URL}/users/${userId}/reviews/latest-friend-article`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        const error = new Error(`Unable to load the latest friend article (${response.status})`)
        error.status = response.status
        throw error
    }

    const payload = await response.json()
    return payload && typeof payload === 'object' && Object.keys(payload).length > 0
        ? payload
        : null
}

export async function getLatestReviewRecommendation(userId) {
    if (!userId) return null

    const response = await fetch(`${HOST_URL}/notifications/review/latest/${userId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            ...authHeader()
        },
    })

    if (!response.ok) {
        const error = new Error(`Unable to load the latest review recommendation (${response.status})`)
        error.status = response.status
        throw error
    }

    const payload = await response.json()
    return payload && typeof payload === 'object' && Object.keys(payload).length > 0
        ? payload
        : null
}

const PROFILE_FEED_ERRORS = {
    401: "Vous devez être connecté pour effectuer cette action. Veuillez vous reconnecter.",
    403: "Accès refusé : ce profil est privé ou vous n'avez pas les droits nécessaires.",
    404: "Élément introuvable.",
    413: "L'image est trop volumineuse (2 Mo maximum).",
    415: "Format d'image non pris en charge.",
}

// Throws an Error (with .status) carrying a user-facing message on any non-2xx response.
// FormData bodies are sent as-is so the browser sets the multipart boundary.
async function profileFeedRequest(path, { method = 'GET', body } = {}) {
    const isForm = typeof FormData !== 'undefined' && body instanceof FormData
    const response = await fetch(`${HOST_URL}/users/${path}`, {
        method,
        headers: {
            'Accept': 'application/json',
            ...(body !== undefined && !isForm ? { 'Content-Type': 'application/json' } : {}),
            ...authHeader()
        },
        body: body === undefined ? undefined : isForm ? body : JSON.stringify(body)
    })

    const text = await response.text()
    let payload = null
    try { payload = text ? JSON.parse(text) : null } catch (e) { payload = null }

    if (!response.ok) {
        let serverMessage = payload?.message || payload?.error || payload?.detail
        if (Array.isArray(payload?.errors)) serverMessage = payload.errors.join(' ')
        else if (payload?.errors && typeof payload.errors === 'object') {
            serverMessage = Object.values(payload.errors).flat().join(' ')
        }
        const error = new Error(
            response.status === 400 || response.status === 422
                ? (serverMessage || "Les données saisies sont invalides.")
                : (serverMessage && [413, 415].includes(response.status)
                    ? serverMessage
                    : PROFILE_FEED_ERRORS[response.status] || serverMessage || `Erreur serveur (${response.status})`)
        )
        error.status = response.status
        throw error
    }
    return payload
}

export async function uploadBanner(userId, file) {
    const body = new FormData()
    body.append('file', file)
    const payload = await profileFeedRequest(`${userId}/banner`, { method: 'POST', body })
    return payload?.banner ?? null
}

export async function deleteBanner(userId) {
    await profileFeedRequest(`${userId}/banner`, { method: 'DELETE' })
    return true
}

export async function getProfileFeed(userId) {
    const payload = await profileFeedRequest(`${userId}/profile-feed`)
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.messages)) return payload.messages
    if (Array.isArray(payload?.posts)) return payload.posts
    return []
}

// With an image file the post is sent as multipart (field "image"); otherwise as JSON.
export async function postProfileFeedMessage(userId, { message, image, article_id, review_id }) {
    let body
    if (image) {
        body = new FormData()
        body.append('image', image)
        if (message) body.append('message', message)
        if (article_id) body.append('article_id', article_id)
        if (review_id) body.append('review_id', review_id)
    } else {
        body = {}
        if (message) body.message = message
        if (article_id) body.article_id = article_id
        if (review_id) body.review_id = review_id
    }
    return (await profileFeedRequest(`${userId}/profile-feed`, { method: 'POST', body })) ?? true
}

export async function uploadProfileFeedImage(userId, messageId, image) {
    const body = new FormData()
    body.append('image', image)
    return (await profileFeedRequest(`${userId}/profile-feed/${messageId}/featured_image`, { method: 'POST', body })) ?? true
}

export async function deleteProfileFeedMessage(userId, messageId) {
    return (await profileFeedRequest(`${userId}/profile-feed/${messageId}`, { method: 'DELETE' })) ?? true
}

export const reportProfileFeedMessage = (userId, messageId, reason, comment) =>
    profileFeedRequest(`${userId}/profile-feed/${messageId}/report`, {
        method: 'POST',
        body: { reason, ...(comment ? { comment } : {}) }
    })

export const likeProfileFeedMessage = (userId, messageId) =>
    profileFeedRequest(`${userId}/profile-feed/${messageId}/like`, { method: 'POST' })

export const unlikeProfileFeedMessage = (userId, messageId) =>
    profileFeedRequest(`${userId}/profile-feed/${messageId}/like`, { method: 'DELETE' })

export async function getProfileFeedComments(userId, messageId) {
    const payload = await profileFeedRequest(`${userId}/profile-feed/${messageId}/comments`)
    if (Array.isArray(payload)) return payload
    if (Array.isArray(payload?.comments)) return payload.comments
    return []
}

export const postProfileFeedComment = (userId, messageId, comment) =>
    profileFeedRequest(`${userId}/profile-feed/${messageId}/comments`, { method: 'POST', body: { comment } })

export async function deleteProfileFeedComment(userId, messageId, commentId) {
    return (await profileFeedRequest(`${userId}/profile-feed/${messageId}/comments/${commentId}`, { method: 'DELETE' })) ?? true
}

export const getProfileFeedReactions = (userId, messageId) =>
    profileFeedRequest(`${userId}/profile-feed/${messageId}/reactions`)

const user = { 
    getAllFriends,
    getAllFriendsWithSharedReviews,
    getFriendRequests,
    getInvitations,
    acceptFriendship,
    addFriend,
    removeFriend,
    getAllPublicUsers,
    getSuggestedFriends,
    updatePrivacySetting,
    searchFriends,
    searchUsers,
    updateUser,
    getFriend,
    getUserReviews,
    setProfilePic,
    uploadBanner,
    deleteBanner,
    getArticle,
    isUserSubscribed,
    getUserIdFromEmail,
    getUserProfile,
    getUsersByLinkedIgo,
    getIgoFromUser,
    addIgoToUser,
    deleteIgoFromUser,
    setIgoPrivate,
    setAllIgoPrivate,
    createFriendGroup,
    getFriendGroupsByUser,
    getFriendsByGroup,
    addFriendToGroup,
    removeFriendFromGroup,
    deleteFriendGroup,
    leaveFriendGroup,
    getProfileFeed,
    postProfileFeedMessage,
    deleteProfileFeedMessage,
    reportProfileFeedMessage,
    uploadProfileFeedImage,
    likeProfileFeedMessage,
    unlikeProfileFeedMessage,
    getProfileFeedComments,
    postProfileFeedComment,
    deleteProfileFeedComment,
    getProfileFeedReactions
};
export default user;
